import styled from 'styled-components';

import { truncateText } from '../../constants/styles';

interface ColorLabelProps {
  $color: string;
  /** Optional max-width override forwarded from `BadgeProps.maxWidth`; defaults to 14rem when unset. */
  $maxWidth?: string;
}
export const ColoredLabel = styled.div<ColorLabelProps>`
  border-radius: ${13 / 16}rem;
  padding: 0.25rem 0.5rem;
  background: ${(props: ColorLabelProps) => props.$color}14;
  color: ${(props: ColorLabelProps) => props.$color};
  font-size: ${13 / 16}rem;
  line-height: normal;
  width: fit-content;
  height: fit-content;
  max-width: ${(props: ColorLabelProps) => props.$maxWidth ?? '14rem'};
  ${truncateText}
`;
